import React from 'react';

import Icon, { Props } from './icon';

export const SettingsIcon: React.FC<Props> = (props: Props) => {
  return (
    <Icon {...props}>
      <g>
        <path
          d="M15.3,22.9c-0.5,0-1-0.2-1.3-0.5l-1.1-1.1c-0.5-0.5-1.3-0.5-1.8,0L10,22.3c-0.6,0.6-1.5,0.7-2.2,0.3l-1.1-0.6
		C6,21.7,5.5,21,5.6,20.2l0.1-1.6c0.1-0.7-0.4-1.4-1.1-1.5l-1.5-0.2c-0.8-0.1-1.4-0.7-1.6-1.5l-0.3-1.2c-0.2-0.8,0.1-1.6,0.8-2
		l1.3-0.9C3.8,10.8,4,10,3.6,9.4L2.9,8C2.5,7.3,2.5,6.5,3,5.8l0.8-1c0.5-0.6,1.3-0.9,2.1-0.7l1.5,0.5C8.1,4.9,8.8,4.5,9,3.9l0.5-1.4
		c0.3-0.8,1-1.3,1.8-1.3l1.2,0c0,0,0,0,0,0c0.8,0,1.5,0.5,1.8,1.2L15,3.9c0.3,0.7,0.9,1,1.6,0.8l1.5-0.5c0.8-0.2,1.6,0,2.1,0.7
		l0.8,1c0.5,0.6,0.6,1.5,0.2,2.2l-0.8,1.4c-0.3,0.6-0.2,1.4,0.4,1.8l1.3,0.9c0.7,0.5,1,1.3,0.8,2l-0.3,1.2c-0.2,0.8-0.8,1.4-1.6,1.5
		l-1.5,0.2c-0.7,0.1-1.2,0.7-1.1,1.5l0.1,1.6c0.1,0.8-0.4,1.6-1.1,1.9l-1.1,0.6C15.9,22.8,15.6,22.9,15.3,22.9z M12,19.2
		c0.7,0,1.5,0.3,2.1,0.8l1.1,1.1c0.1,0.1,0.2,0.1,0.3,0l1.1-0.6c0.1,0,0.1-0.1,0.1-0.3l-0.1-1.6c-0.1-1.6,1-3,2.6-3.3l1.5-0.2
		c0.1,0,0.2-0.1,0.2-0.2l0.3-1.2c0-0.1,0-0.2-0.1-0.3l-1.3-0.9c-1.3-0.9-1.7-2.7-0.9-4.1l0.8-1.4c0.1-0.1,0-0.2,0-0.3l-0.8-1
		c-0.1-0.1-0.2-0.1-0.2-0.1l-1.5,0.5C15.6,6.8,14,6,13.4,4.5L12.8,3c0-0.1-0.1-0.2-0.2-0.2h0l-1.2,0c-0.1,0-0.2,0.1-0.2,0.2
		l-0.5,1.4C10,6,8.4,6.8,6.9,6.3L5.4,5.8c-0.1,0-0.2,0-0.2,0.1l-0.8,1C4.3,7,4.3,7.1,4.3,7.2l0.8,1.4c0.8,1.4,0.4,3.2-0.9,4.1
		L3,13.5c-0.1,0.1-0.1,0.2-0.1,0.3L3.1,15c0,0.1,0.1,0.2,0.2,0.2c0,0,0,0,0,0l1.5,0.2c1.5,0.2,2.7,1.7,2.6,3.3l-0.1,1.6
		c0,0.1,0,0.2,0.1,0.3l1.1,0.6c0.1,0,0.2,0,0.3,0L9.9,20C10.5,19.5,11.3,19.2,12,19.2z"
        />
      </g>
      <g>
        <path
          d="M12,15.9C12,15.9,12,15.9,12,15.9c-1,0-2-0.4-2.7-1.1c-1.5-1.5-1.5-3.9,0-5.4c1.4-1.5,3.9-1.5,5.4,0
		c0,0,0,0,0,0c1.5,1.5,1.5,3.9,0,5.4C14,15.5,13,15.9,12,15.9z M12,9.9c-0.6,0-1.1,0.2-1.5,0.6c-0.8,0.8-0.8,2.2,0,3.1
		c0.4,0.4,0.9,0.6,1.5,0.6h0c0.6,0,1.1-0.2,1.5-0.6c0.8-0.8,0.8-2.2,0-3.1C13.1,10.1,12.6,9.9,12,9.9z"
        />
      </g>
    </Icon>
  );
};

export default React.memo(SettingsIcon);
